module.exports = __webpack_public_path__ + "static/media/icon_plate.4f67fa29.svg";